import { render, staticRenderFns } from "./ProfileLink.vue?vue&type=template&id=1031a94e&"
import script from "./ProfileLink.vue?vue&type=script&lang=ts&"
export * from "./ProfileLink.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports